"use client";

import { Fragment, useCallback, useContext, useState } from "react";

import Sticky from "components/sticky";
import { CategoryList } from "@/components/categories";
import { Navbar, NavigationList } from "@/components/navbar";
import { MobileMenu } from "@/components/navbar/mobile-menu";
import { MobileNavigationBar } from "@/components/mobile-navigation";
import { Header, HeaderCart, HeaderLogin } from "@/components/header";
import { MobileHeader, HeaderSearch } from "@/components/header/mobile-header";
import { Topbar, TopbarSocialLinks } from "components/topbar";
import { SearchInput, SearchInputWithCategory } from "components/search-box";
import { AuthContext } from "../../../contexts/AuthContext";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { IconButton } from "@mui/material";
import LocationModal from "@/components/newsletter";


export default function ShopLayout1({
  children,
  data,
  categories
}) {
  const {
    footer,
    header,
    topbar,
    mobileNavigation
  } = data;

  const { auth } = useContext(AuthContext);

  const [location, setLocation] = useState(false)

  const [isFixed, setIsFixed] = useState(false);
  const toggleIsFixed = useCallback(fixed => setIsFixed(fixed), []);
  const MOBILE_VERSION_HEADER = <MobileHeader>
    <MobileHeader.Left>
      <MobileMenu navigation={categories} />
      <IconButton onClick={() => {
        setLocation(true)
      }}>
        <LocationOnIcon style={{ color: "#555" }} />
      </IconButton>
    </MobileHeader.Left>
    {location && <LocationModal show={location} delay={100} onClose={() => setLocation(false)} />}

    <MobileHeader.Logo logoUrl={mobileNavigation.logo} />

    <MobileHeader.Right>

      <HeaderSearch>
        <SearchInput />
      </HeaderSearch>

      <HeaderLogin />
      <HeaderCart />
    </MobileHeader.Right>
  </MobileHeader>;
  return <Fragment>
    <Topbar label={topbar.label} title={topbar.title}>

      <Topbar.Right>
        {/*<TopbarLanguageSelector languages={topbar.languageOptions} />*/}
        <TopbarSocialLinks links={topbar.socials} />
      </Topbar.Right>
    </Topbar>

    {/* HEADER */}
    <Sticky fixedOn={0} onSticky={toggleIsFixed} scrollDistance={300}>
      <Header mobileHeader={MOBILE_VERSION_HEADER}>
        <Header.Logo url={header.logo} />

        {false && <Header.CategoryDropdown>
          <CategoryList categories={header.categoryMenus} />
        </Header.CategoryDropdown>}

        <Header.Mid>
          <SearchInputWithCategory categories={header.categories} />
        </Header.Mid>

        <Header.Right>
          <HeaderLogin />
          <HeaderCart />
        </Header.Right>
      </Header>
    </Sticky>

    {/* NAVIGATION BAR */}
    <Navbar border={1} elevation={0} isAuth={auth.isAuthenticated} navigation={<NavigationList navigation={header.navigation} />} categories={<CategoryList categories={header.categoryMenus} />} />

    {/* BODY CONTENT */}
    {children}
    <div style={{ marginBottom: 20 }}>

    </div>

    {/* SMALL DEVICE BOTTOM NAVIGATION */}
    <MobileNavigationBar navigation={mobileNavigation.version1} />

    {/* FOOTER SECTION */}

  </Fragment>;
}